import React, { useState, useEffect } from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { toast } from 'react-toastify';

const ManufacturerDropdown = ({ fetchManufacturers, onChange, setSelectedManufacturer, selectedManufacturer }) => {
  const [linkedCompanies, setLinkedCompanies] = useState([]);

  const GetManufacturers = async () => {
    const { data, message, error } = await fetchManufacturers();
    if (!error) {
        setLinkedCompanies(data);
        if (data.length > 0 ) {
            setSelectedManufacturer(data[0].manufacturer_id);
        }
    } else {
        toast.error(message);
    }
  };

  useEffect(() => {
    GetManufacturers();
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedManufacturer(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <FormControl fullWidth sx={{ mb: 2 }}>
      <InputLabel>Select Company</InputLabel>
      <Select
        label="Select Company"
        value={selectedManufacturer}
        onChange={handleChange}
      >
        {linkedCompanies.map((company) => (
          <MenuItem key={company.manufacturer_id} value={company.manufacturer_id}>
            {company.manufacturer_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ManufacturerDropdown;